import { NavItemExternalLink } from '@/domain/navigation/features/navigation/components/MobileNavItem/NavItem';
import { useProfile } from '@/hooks';
import { buildLink } from '@/utils';
import { useTranslation } from 'react-i18next';

export function useDienstplanSubmenuItems() {
  const { t } = useTranslation();
  const profile = useProfile();
  const manager = profile.manager;
  const menuItems = [];

  menuItems.push(
    <NavItemExternalLink href={buildLink('dienstplanPersonal')}>
      {t('entities.staff')}
    </NavItemExternalLink>,
  );
  menuItems.push(
    <NavItemExternalLink href={buildLink('dienstplanSchicht')}>
      {t('entities.shift_other')}
    </NavItemExternalLink>,
  );
  if (manager.rechte.dienstplan.schichtvorlagen) {
    menuItems.push(
      <NavItemExternalLink href={buildLink('dienstplanVorlage')}>
        {t('entities.template_other')}
      </NavItemExternalLink>,
    );
  }

  return menuItems;
}
